module.exports = __webpack_public_path__ + "static/media/henry.fddb80fc.png";